import * as React from 'react';



export default class WorkkardDetail extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (	  
	  <svg className={this.props.className} viewBox="0 0 16 16" xmlnsXlink="http://www.w3.org/1999/xlink">
		<g id="Symbols" strokeWidth="1" fillRule="evenodd">
        <g id="icons/workDetails/active">
            <polygon id="Fill-1" fill="#2AB7EA" stroke="#2AB7EA" points="12.7281808 15 14.3 15 14.3 2 12.7281808 2"></polygon>
            <g id="Group" transform="translate(2.000000, 2.000000)" strokeLinecap="round" strokeLinejoin="round">
                <g id="Group-56-Copy-2">
                    <g id="Page-1">
                        <path d="M12,13 L0,13 C0.21954708,13 0,12.7775556 0,13 L0,0 C0,0.222444444 0.21954708,0 0,0 L12,0 C11.7804529,0 12,0.222444444 12,0 L12,13 C12,12.7775556 11.7804529,13 12,13 Z" id="Stroke-1"></path>
                    </g>
                </g>
                <path d="M2.5,2.5 L9.5,2.5" id="Line"></path>
                <path d="M2.5,4.5 L9.5,4.5" id="Line-Copy"></path>
                <path d="M2.5,6.5 L7.5,6.5" id="Line-Copy-2"></path>
            </g>
        </g>
    </g>
	</svg>

    )
  }
}
